var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { shallowRef, watchEffect, readonly, ref, watch, customRef, getCurrentScope, onScopeDispose, effectScope, getCurrentInstance, provide, inject, isVue3, version, isRef, unref, computed, reactive, toRefs as toRefs$1, toRef as toRef$1, isVue2, set as set$1, onBeforeMount, nextTick, onBeforeUnmount, onMounted, onUnmounted, isReactive } from 'vue-demi';
function computedEager(fn, options) {
    var _a;
    var result = shallowRef();
    watchEffect(function () {
        result.value = fn();
    }, __assign(__assign({}, options), { flush: (_a = options == null ? void 0 : options.flush) != null ? _a : "sync" }));
    return readonly(result);
}
function computedWithControl(source, fn) {
    var v = void 0;
    var track;
    var trigger;
    var dirty = ref(true);
    var update = function () {
        dirty.value = true;
        trigger();
    };
    watch(source, update, { flush: "sync" });
    var get = typeof fn === "function" ? fn : fn.get;
    var set = typeof fn === "function" ? void 0 : fn.set;
    var result = customRef(function (_track, _trigger) {
        track = _track;
        trigger = _trigger;
        return {
            get: function () {
                if (dirty.value) {
                    v = get();
                    dirty.value = false;
                }
                track();
                return v;
            },
            set: function (v2) {
                set == null ? void 0 : set(v2);
            }
        };
    });
    if (Object.isExtensible(result))
        result.trigger = update;
    return result;
}
function tryOnScopeDispose(fn) {
    if (getCurrentScope()) {
        onScopeDispose(fn);
        return true;
    }
    return false;
}
function createEventHook() {
    var fns = /* @__PURE__ */ new Set();
    var off = function (fn) {
        fns.delete(fn);
    };
    var on = function (fn) {
        fns.add(fn);
        var offFn = function () { return off(fn); };
        tryOnScopeDispose(offFn);
        return {
            off: offFn
        };
    };
    var trigger = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return Promise.all(Array.from(fns).map(function (fn) { return fn.apply(void 0, __spreadArray([], __read(args), false)); }));
    };
    return {
        on: on,
        off: off,
        trigger: trigger
    };
}
function createGlobalState(stateFactory) {
    var initialized = false;
    var state;
    var scope = effectScope(true);
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!initialized) {
            state = scope.run(function () { return stateFactory.apply(void 0, __spreadArray([], __read(args), false)); });
            initialized = true;
        }
        return state;
    };
}
var localProvidedStateMap = /* @__PURE__ */ new WeakMap();
var provideLocal = function (key, value) {
    var _a;
    var instance = (_a = getCurrentInstance()) == null ? void 0 : _a.proxy;
    if (instance == null)
        throw new Error("provideLocal must be called in setup");
    if (!localProvidedStateMap.has(instance))
        localProvidedStateMap.set(instance, /* @__PURE__ */ Object.create(null));
    var localProvidedState = localProvidedStateMap.get(instance);
    localProvidedState[key] = value;
    provide(key, value);
};
var injectLocal = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var _a;
    var key = args[0];
    var instance = (_a = getCurrentInstance()) == null ? void 0 : _a.proxy;
    if (instance == null)
        throw new Error("injectLocal must be called in setup");
    if (localProvidedStateMap.has(instance) && key in localProvidedStateMap.get(instance))
        return localProvidedStateMap.get(instance)[key];
    return inject.apply(void 0, __spreadArray([], __read(args), false));
};
function createInjectionState(composable, options) {
    var key = (options == null ? void 0 : options.injectionKey) || Symbol(composable.name || "InjectionState");
    var defaultValue = options == null ? void 0 : options.defaultValue;
    var useProvidingState = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var state = composable.apply(void 0, __spreadArray([], __read(args), false));
        provideLocal(key, state);
        return state;
    };
    var useInjectedState = function () { return injectLocal(key, defaultValue); };
    return [useProvidingState, useInjectedState];
}
function createSharedComposable(composable) {
    var subscribers = 0;
    var state;
    var scope;
    var dispose = function () {
        subscribers -= 1;
        if (scope && subscribers <= 0) {
            scope.stop();
            state = void 0;
            scope = void 0;
        }
    };
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        subscribers += 1;
        if (!state) {
            scope = effectScope(true);
            state = scope.run(function () { return composable.apply(void 0, __spreadArray([], __read(args), false)); });
        }
        tryOnScopeDispose(dispose);
        return state;
    };
}
function extendRef(ref, extend, _c) {
    var e_1, _d;
    var _e = _c === void 0 ? {} : _c, _f = _e.enumerable, enumerable = _f === void 0 ? false : _f, _g = _e.unwrap, unwrap = _g === void 0 ? true : _g;
    if (!isVue3 && !version.startsWith("2.7.")) {
        if (process.env.NODE_ENV !== "production")
            throw new Error("[VueUse] extendRef only works in Vue 2.7 or above.");
        return;
    }
    var _loop_1 = function (key, value) {
        if (key === "value")
            return "continue";
        if (isRef(value) && unwrap) {
            Object.defineProperty(ref, key, {
                get: function () {
                    return value.value;
                },
                set: function (v) {
                    value.value = v;
                },
                enumerable: enumerable
            });
        }
        else {
            Object.defineProperty(ref, key, { value: value, enumerable: enumerable });
        }
    };
    try {
        for (var _h = __values(Object.entries(extend)), _j = _h.next(); !_j.done; _j = _h.next()) {
            var _k = __read(_j.value, 2), key = _k[0], value = _k[1];
            _loop_1(key, value);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_j && !_j.done && (_d = _h.return)) _d.call(_h);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return ref;
}
function get(obj, key) {
    if (key == null)
        return unref(obj);
    return unref(obj)[key];
}
function isDefined(v) {
    return unref(v) != null;
}
function makeDestructurable(obj, arr) {
    if (typeof Symbol !== "undefined") {
        var clone = __assign({}, obj);
        Object.defineProperty(clone, Symbol.iterator, {
            enumerable: false,
            value: function () {
                var index = 0;
                return {
                    next: function () { return ({
                        value: arr[index++],
                        done: index > arr.length
                    }); }
                };
            }
        });
        return clone;
    }
    else {
        return Object.assign(__spreadArray([], __read(arr), false), obj);
    }
}
function toValue(r) {
    return typeof r === "function" ? r() : unref(r);
}
var resolveUnref = toValue;
function reactify(fn, options) {
    var unrefFn = (options == null ? void 0 : options.computedGetter) === false ? unref : toValue;
    return function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return computed(function () { return fn.apply(_this, args.map(function (i) { return unrefFn(i); })); });
    };
}
function reactifyObject(obj, optionsOrKeys) {
    if (optionsOrKeys === void 0) { optionsOrKeys = {}; }
    var keys = [];
    var options;
    if (Array.isArray(optionsOrKeys)) {
        keys = optionsOrKeys;
    }
    else {
        options = optionsOrKeys;
        var _c = optionsOrKeys.includeOwnProperties, includeOwnProperties = _c === void 0 ? true : _c;
        keys.push.apply(keys, __spreadArray([], __read(Object.keys(obj)), false));
        if (includeOwnProperties)
            keys.push.apply(keys, __spreadArray([], __read(Object.getOwnPropertyNames(obj)), false));
    }
    return Object.fromEntries(keys.map(function (key) {
        var value = obj[key];
        return [
            key,
            typeof value === "function" ? reactify(value.bind(obj), options) : value
        ];
    }));
}
function toReactive(objectRef) {
    if (!isRef(objectRef))
        return reactive(objectRef);
    var proxy = new Proxy({}, {
        get: function (_, p, receiver) {
            return unref(Reflect.get(objectRef.value, p, receiver));
        },
        set: function (_, p, value) {
            if (isRef(objectRef.value[p]) && !isRef(value))
                objectRef.value[p].value = value;
            else
                objectRef.value[p] = value;
            return true;
        },
        deleteProperty: function (_, p) {
            return Reflect.deleteProperty(objectRef.value, p);
        },
        has: function (_, p) {
            return Reflect.has(objectRef.value, p);
        },
        ownKeys: function () {
            return Object.keys(objectRef.value);
        },
        getOwnPropertyDescriptor: function () {
            return {
                enumerable: true,
                configurable: true
            };
        }
    });
    return reactive(proxy);
}
function reactiveComputed(fn) {
    return toReactive(computed(fn));
}
function reactiveOmit(obj) {
    var keys = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        keys[_i - 1] = arguments[_i];
    }
    var flatKeys = keys.flat();
    var predicate = flatKeys[0];
    return reactiveComputed(function () { return typeof predicate === "function" ? Object.fromEntries(Object.entries(toRefs$1(obj)).filter(function (_c) {
        var _d = __read(_c, 2), k = _d[0], v = _d[1];
        return !predicate(toValue(v), k);
    })) : Object.fromEntries(Object.entries(toRefs$1(obj)).filter(function (e) { return !flatKeys.includes(e[0]); })); });
}
var isClient = typeof window !== "undefined" && typeof document !== "undefined";
var isWorker = typeof WorkerGlobalScope !== "undefined" && globalThis instanceof WorkerGlobalScope;
var isDef = function (val) { return typeof val !== "undefined"; };
var notNullish = function (val) { return val != null; };
var assert = function (condition) {
    var infos = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        infos[_i - 1] = arguments[_i];
    }
    if (!condition)
        console.warn.apply(console, __spreadArray([], __read(infos), false));
};
var toString = Object.prototype.toString;
var isObject = function (val) { return toString.call(val) === "[object Object]"; };
var now = function () { return Date.now(); };
var timestamp = function () { return +Date.now(); };
var clamp = function (n, min, max) { return Math.min(max, Math.max(min, n)); };
var noop = function () {
};
var rand = function (min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
};
var hasOwn = function (val, key) { return Object.prototype.hasOwnProperty.call(val, key); };
var isIOS = /* @__PURE__ */ getIsIOS();
function getIsIOS() {
    var _a, _b;
    return isClient && ((_a = window == null ? void 0 : window.navigator) == null ? void 0 : _a.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((_b = window == null ? void 0 : window.navigator) == null ? void 0 : _b.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function createFilterWrapper(filter, fn) {
    function wrapper() {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new Promise(function (resolve, reject) {
            Promise.resolve(filter(function () { return fn.apply(_this, args); }, { fn: fn, thisArg: _this, args: args })).then(resolve).catch(reject);
        });
    }
    return wrapper;
}
var bypassFilter = function (invoke) {
    return invoke();
};
function debounceFilter(ms, options) {
    if (options === void 0) { options = {}; }
    var timer;
    var maxTimer;
    var lastRejector = noop;
    var _clearTimeout = function (timer2) {
        clearTimeout(timer2);
        lastRejector();
        lastRejector = noop;
    };
    var filter = function (invoke) {
        var duration = toValue(ms);
        var maxDuration = toValue(options.maxWait);
        if (timer)
            _clearTimeout(timer);
        if (duration <= 0 || maxDuration !== void 0 && maxDuration <= 0) {
            if (maxTimer) {
                _clearTimeout(maxTimer);
                maxTimer = null;
            }
            return Promise.resolve(invoke());
        }
        return new Promise(function (resolve, reject) {
            lastRejector = options.rejectOnCancel ? reject : resolve;
            if (maxDuration && !maxTimer) {
                maxTimer = setTimeout(function () {
                    if (timer)
                        _clearTimeout(timer);
                    maxTimer = null;
                    resolve(invoke());
                }, maxDuration);
            }
            timer = setTimeout(function () {
                if (maxTimer)
                    _clearTimeout(maxTimer);
                maxTimer = null;
                resolve(invoke());
            }, duration);
        });
    };
    return filter;
}
function throttleFilter() {
    var _c, _d, _e, _f, _g, _h, _j, _k;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var lastExec = 0;
    var timer;
    var isLeading = true;
    var lastRejector = noop;
    var lastValue;
    var ms;
    var trailing;
    var leading;
    var rejectOnCancel;
    if (!isRef(args[0]) && typeof args[0] === "object")
        (_c = args[0], ms = _c.delay, _d = _c.trailing, trailing = _d === void 0 ? true : _d, _e = _c.leading, leading = _e === void 0 ? true : _e, _f = _c.rejectOnCancel, rejectOnCancel = _f === void 0 ? false : _f);
    else
        _g = __read(args, 4), ms = _g[0], _h = _g[1], trailing = _h === void 0 ? true : _h, _j = _g[2], leading = _j === void 0 ? true : _j, _k = _g[3], rejectOnCancel = _k === void 0 ? false : _k;
    var clear = function () {
        if (timer) {
            clearTimeout(timer);
            timer = void 0;
            lastRejector();
            lastRejector = noop;
        }
    };
    var filter = function (_invoke) {
        var duration = toValue(ms);
        var elapsed = Date.now() - lastExec;
        var invoke = function () {
            return lastValue = _invoke();
        };
        clear();
        if (duration <= 0) {
            lastExec = Date.now();
            return invoke();
        }
        if (elapsed > duration && (leading || !isLeading)) {
            lastExec = Date.now();
            invoke();
        }
        else if (trailing) {
            lastValue = new Promise(function (resolve, reject) {
                lastRejector = rejectOnCancel ? reject : resolve;
                timer = setTimeout(function () {
                    lastExec = Date.now();
                    isLeading = true;
                    resolve(invoke());
                    clear();
                }, Math.max(0, duration - elapsed));
            });
        }
        if (!leading && !timer)
            timer = setTimeout(function () { return isLeading = true; }, duration);
        isLeading = false;
        return lastValue;
    };
    return filter;
}
function pausableFilter(extendFilter) {
    if (extendFilter === void 0) { extendFilter = bypassFilter; }
    var isActive = ref(true);
    function pause() {
        isActive.value = false;
    }
    function resume() {
        isActive.value = true;
    }
    var eventFilter = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (isActive.value)
            extendFilter.apply(void 0, __spreadArray([], __read(args), false));
    };
    return { isActive: readonly(isActive), pause: pause, resume: resume, eventFilter: eventFilter };
}
var directiveHooks = {
    mounted: isVue3 ? "mounted" : "inserted",
    updated: isVue3 ? "updated" : "componentUpdated",
    unmounted: isVue3 ? "unmounted" : "unbind"
};
function cacheStringFunction(fn) {
    var cache = /* @__PURE__ */ Object.create(null);
    return function (str) {
        var hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
}
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cacheStringFunction(function (str) { return str.replace(hyphenateRE, "-$1").toLowerCase(); });
var camelizeRE = /-(\w)/g;
var camelize = cacheStringFunction(function (str) {
    return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ""; });
});
function promiseTimeout(ms, throwOnTimeout, reason) {
    if (throwOnTimeout === void 0) { throwOnTimeout = false; }
    if (reason === void 0) { reason = "Timeout"; }
    return new Promise(function (resolve, reject) {
        if (throwOnTimeout)
            setTimeout(function () { return reject(reason); }, ms);
        else
            setTimeout(resolve, ms);
    });
}
function identity(arg) {
    return arg;
}
function createSingletonPromise(fn) {
    var _this = this;
    var _promise;
    function wrapper() {
        if (!_promise)
            _promise = fn();
        return _promise;
    }
    wrapper.reset = function () { return __awaiter(_this, void 0, void 0, function () {
        var _prev;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _prev = _promise;
                    _promise = void 0;
                    if (!_prev) return [3 /*break*/, 2];
                    return [4 /*yield*/, _prev];
                case 1:
                    _c.sent();
                    _c.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    return wrapper;
}
function invoke(fn) {
    return fn();
}
function containsProp(obj) {
    var props = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        props[_i - 1] = arguments[_i];
    }
    return props.some(function (k) { return k in obj; });
}
function increaseWithUnit(target, delta) {
    var _a;
    if (typeof target === "number")
        return target + delta;
    var value = ((_a = target.match(/^-?\d+\.?\d*/)) == null ? void 0 : _a[0]) || "";
    var unit = target.slice(value.length);
    var result = Number.parseFloat(value) + delta;
    if (Number.isNaN(result))
        return target;
    return result + unit;
}
function objectPick(obj, keys, omitUndefined) {
    if (omitUndefined === void 0) { omitUndefined = false; }
    return keys.reduce(function (n, k) {
        if (k in obj) {
            if (!omitUndefined || obj[k] !== void 0)
                n[k] = obj[k];
        }
        return n;
    }, {});
}
function objectOmit(obj, keys, omitUndefined) {
    if (omitUndefined === void 0) { omitUndefined = false; }
    return Object.fromEntries(Object.entries(obj).filter(function (_c) {
        var _d = __read(_c, 2), key = _d[0], value = _d[1];
        return (!omitUndefined || value !== void 0) && !keys.includes(key);
    }));
}
function objectEntries(obj) {
    return Object.entries(obj);
}
function getLifeCycleTarget(target) {
    return target || getCurrentInstance();
}
function toRef() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (args.length !== 1)
        return toRef$1.apply(void 0, __spreadArray([], __read(args), false));
    var r = args[0];
    return typeof r === "function" ? readonly(customRef(function () { return ({ get: r, set: noop }); })) : ref(r);
}
var resolveRef = toRef;
function reactivePick(obj) {
    var keys = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        keys[_i - 1] = arguments[_i];
    }
    var flatKeys = keys.flat();
    var predicate = flatKeys[0];
    return reactiveComputed(function () { return typeof predicate === "function" ? Object.fromEntries(Object.entries(toRefs$1(obj)).filter(function (_c) {
        var _d = __read(_c, 2), k = _d[0], v = _d[1];
        return predicate(toValue(v), k);
    })) : Object.fromEntries(flatKeys.map(function (k) { return [k, toRef(obj, k)]; })); });
}
function refAutoReset(defaultValue, afterMs) {
    if (afterMs === void 0) { afterMs = 1e4; }
    return customRef(function (track, trigger) {
        var value = toValue(defaultValue);
        var timer;
        var resetAfter = function () { return setTimeout(function () {
            value = toValue(defaultValue);
            trigger();
        }, toValue(afterMs)); };
        tryOnScopeDispose(function () {
            clearTimeout(timer);
        });
        return {
            get: function () {
                track();
                return value;
            },
            set: function (newValue) {
                value = newValue;
                trigger();
                clearTimeout(timer);
                timer = resetAfter();
            }
        };
    });
}
function useDebounceFn(fn, ms, options) {
    if (ms === void 0) { ms = 200; }
    if (options === void 0) { options = {}; }
    return createFilterWrapper(debounceFilter(ms, options), fn);
}
function refDebounced(value, ms, options) {
    if (ms === void 0) { ms = 200; }
    if (options === void 0) { options = {}; }
    var debounced = ref(value.value);
    var updater = useDebounceFn(function () {
        debounced.value = value.value;
    }, ms, options);
    watch(value, function () { return updater(); });
    return debounced;
}
function refDefault(source, defaultValue) {
    return computed({
        get: function () {
            var _a;
            return (_a = source.value) != null ? _a : defaultValue;
        },
        set: function (value) {
            source.value = value;
        }
    });
}
function useThrottleFn(fn, ms, trailing, leading, rejectOnCancel) {
    if (ms === void 0) { ms = 200; }
    if (trailing === void 0) { trailing = false; }
    if (leading === void 0) { leading = true; }
    if (rejectOnCancel === void 0) { rejectOnCancel = false; }
    return createFilterWrapper(throttleFilter(ms, trailing, leading, rejectOnCancel), fn);
}
function refThrottled(value, delay, trailing, leading) {
    if (delay === void 0) { delay = 200; }
    if (trailing === void 0) { trailing = true; }
    if (leading === void 0) { leading = true; }
    if (delay <= 0)
        return value;
    var throttled = ref(value.value);
    var updater = useThrottleFn(function () {
        throttled.value = value.value;
    }, delay, trailing, leading);
    watch(value, function () { return updater(); });
    return throttled;
}
function refWithControl(initial, options) {
    if (options === void 0) { options = {}; }
    var source = initial;
    var track;
    var trigger;
    var ref = customRef(function (_track, _trigger) {
        track = _track;
        trigger = _trigger;
        return {
            get: function () {
                return get();
            },
            set: function (v) {
                set(v);
            }
        };
    });
    function get(tracking) {
        if (tracking === void 0) { tracking = true; }
        if (tracking)
            track();
        return source;
    }
    function set(value, triggering) {
        if (triggering === void 0) { triggering = true; }
        var _a, _b;
        if (value === source)
            return;
        var old = source;
        if (((_a = options.onBeforeChange) == null ? void 0 : _a.call(options, value, old)) === false)
            return;
        source = value;
        (_b = options.onChanged) == null ? void 0 : _b.call(options, value, old);
        if (triggering)
            trigger();
    }
    var untrackedGet = function () { return get(false); };
    var silentSet = function (v) { return set(v, false); };
    var peek = function () { return get(false); };
    var lay = function (v) { return set(v, false); };
    return extendRef(ref, {
        get: get,
        set: set,
        untrackedGet: untrackedGet,
        silentSet: silentSet,
        peek: peek,
        lay: lay
    }, { enumerable: true });
}
var controlledRef = refWithControl;
function set() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (args.length === 2) {
        var _c = __read(args, 2), ref_1 = _c[0], value = _c[1];
        ref_1.value = value;
    }
    if (args.length === 3) {
        if (isVue2) {
            set$1.apply(void 0, __spreadArray([], __read(args), false));
        }
        else {
            var _d = __read(args, 3), target = _d[0], key = _d[1], value = _d[2];
            target[key] = value;
        }
    }
}
function watchWithFilter(source, cb, options) {
    if (options === void 0) { options = {}; }
    var _c = options.eventFilter, eventFilter = _c === void 0 ? bypassFilter : _c, watchOptions = __rest(options, ["eventFilter"]);
    return watch(source, createFilterWrapper(eventFilter, cb), watchOptions);
}
function watchPausable(source, cb, options) {
    if (options === void 0) { options = {}; }
    var filter = options.eventFilter, watchOptions = __rest(options, ["eventFilter"]);
    var _c = pausableFilter(filter), eventFilter = _c.eventFilter, pause = _c.pause, resume = _c.resume, isActive = _c.isActive;
    var stop = watchWithFilter(source, cb, __assign(__assign({}, watchOptions), { eventFilter: eventFilter }));
    return { stop: stop, pause: pause, resume: resume, isActive: isActive };
}
function syncRef(left, right) {
    var _c = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _c[_i - 2] = arguments[_i];
    }
    var _d = __read(_c, 1), options = _d[0];
    var _e = options || {}, _f = _e.flush, flush = _f === void 0 ? "sync" : _f, _g = _e.deep, deep = _g === void 0 ? false : _g, _h = _e.immediate, immediate = _h === void 0 ? true : _h, _j = _e.direction, direction = _j === void 0 ? "both" : _j, _k = _e.transform, transform = _k === void 0 ? {} : _k;
    var watchers = [];
    var transformLTR = "ltr" in transform && transform.ltr || (function (v) { return v; });
    var transformRTL = "rtl" in transform && transform.rtl || (function (v) { return v; });
    if (direction === "both" || direction === "ltr") {
        watchers.push(watchPausable(left, function (newValue) {
            watchers.forEach(function (w) { return w.pause(); });
            right.value = transformLTR(newValue);
            watchers.forEach(function (w) { return w.resume(); });
        }, { flush: flush, deep: deep, immediate: immediate }));
    }
    if (direction === "both" || direction === "rtl") {
        watchers.push(watchPausable(right, function (newValue) {
            watchers.forEach(function (w) { return w.pause(); });
            left.value = transformRTL(newValue);
            watchers.forEach(function (w) { return w.resume(); });
        }, { flush: flush, deep: deep, immediate: immediate }));
    }
    var stop = function () {
        watchers.forEach(function (w) { return w.stop(); });
    };
    return stop;
}
function syncRefs(source, targets, options) {
    if (options === void 0) { options = {}; }
    var _c = options.flush, flush = _c === void 0 ? "sync" : _c, _d = options.deep, deep = _d === void 0 ? false : _d, _e = options.immediate, immediate = _e === void 0 ? true : _e;
    if (!Array.isArray(targets))
        targets = [targets];
    return watch(source, function (newValue) { return targets.forEach(function (target) { return target.value = newValue; }); }, { flush: flush, deep: deep, immediate: immediate });
}
function toRefs(objectRef, options) {
    if (options === void 0) { options = {}; }
    if (!isRef(objectRef))
        return toRefs$1(objectRef);
    var result = Array.isArray(objectRef.value) ? Array.from({ length: objectRef.value.length }) : {};
    var _loop_2 = function (key) {
        result[key] = customRef(function () { return ({
            get: function () {
                return objectRef.value[key];
            },
            set: function (v) {
                var _c;
                var _a;
                var replaceRef = (_a = toValue(options.replaceRef)) != null ? _a : true;
                if (replaceRef) {
                    if (Array.isArray(objectRef.value)) {
                        var copy = __spreadArray([], __read(objectRef.value), false);
                        copy[key] = v;
                        objectRef.value = copy;
                    }
                    else {
                        var newObject = __assign(__assign({}, objectRef.value), (_c = {}, _c[key] = v, _c));
                        Object.setPrototypeOf(newObject, Object.getPrototypeOf(objectRef.value));
                        objectRef.value = newObject;
                    }
                }
                else {
                    objectRef.value[key] = v;
                }
            }
        }); });
    };
    for (var key in objectRef.value) {
        _loop_2(key);
    }
    return result;
}
function tryOnBeforeMount(fn, sync, target) {
    if (sync === void 0) { sync = true; }
    var instance = getLifeCycleTarget(target);
    if (instance)
        onBeforeMount(fn, target);
    else if (sync)
        fn();
    else
        nextTick(fn);
}
function tryOnBeforeUnmount(fn, target) {
    var instance = getLifeCycleTarget(target);
    if (instance)
        onBeforeUnmount(fn, target);
}
function tryOnMounted(fn, sync, target) {
    if (sync === void 0) { sync = true; }
    var instance = getLifeCycleTarget();
    if (instance)
        onMounted(fn, target);
    else if (sync)
        fn();
    else
        nextTick(fn);
}
function tryOnUnmounted(fn, target) {
    var instance = getLifeCycleTarget(target);
    if (instance)
        onUnmounted(fn, target);
}
function createUntil(r, isNot) {
    if (isNot === void 0) { isNot = false; }
    function toMatch(condition, _c) {
        var _d = _c === void 0 ? {} : _c, _e = _d.flush, flush = _e === void 0 ? "sync" : _e, _f = _d.deep, deep = _f === void 0 ? false : _f, timeout = _d.timeout, throwOnTimeout = _d.throwOnTimeout;
        var stop = null;
        var watcher = new Promise(function (resolve) {
            stop = watch(r, function (v) {
                if (condition(v) !== isNot) {
                    stop == null ? void 0 : stop();
                    resolve(v);
                }
            }, {
                flush: flush,
                deep: deep,
                immediate: true
            });
        });
        var promises = [watcher];
        if (timeout != null) {
            promises.push(promiseTimeout(timeout, throwOnTimeout).then(function () { return toValue(r); }).finally(function () { return stop == null ? void 0 : stop(); }));
        }
        return Promise.race(promises);
    }
    function toBe(value, options) {
        if (!isRef(value))
            return toMatch(function (v) { return v === value; }, options);
        var _c = options != null ? options : {}, _d = _c.flush, flush = _d === void 0 ? "sync" : _d, _e = _c.deep, deep = _e === void 0 ? false : _e, timeout = _c.timeout, throwOnTimeout = _c.throwOnTimeout;
        var stop = null;
        var watcher = new Promise(function (resolve) {
            stop = watch([r, value], function (_c) {
                var _d = __read(_c, 2), v1 = _d[0], v2 = _d[1];
                if (isNot !== (v1 === v2)) {
                    stop == null ? void 0 : stop();
                    resolve(v1);
                }
            }, {
                flush: flush,
                deep: deep,
                immediate: true
            });
        });
        var promises = [watcher];
        if (timeout != null) {
            promises.push(promiseTimeout(timeout, throwOnTimeout).then(function () { return toValue(r); }).finally(function () {
                stop == null ? void 0 : stop();
                return toValue(r);
            }));
        }
        return Promise.race(promises);
    }
    function toBeTruthy(options) {
        return toMatch(function (v) { return Boolean(v); }, options);
    }
    function toBeNull(options) {
        return toBe(null, options);
    }
    function toBeUndefined(options) {
        return toBe(void 0, options);
    }
    function toBeNaN(options) {
        return toMatch(Number.isNaN, options);
    }
    function toContains(value, options) {
        return toMatch(function (v) {
            var array = Array.from(v);
            return array.includes(value) || array.includes(toValue(value));
        }, options);
    }
    function changed(options) {
        return changedTimes(1, options);
    }
    function changedTimes(n, options) {
        if (n === void 0) { n = 1; }
        var count = -1;
        return toMatch(function () {
            count += 1;
            return count >= n;
        }, options);
    }
    if (Array.isArray(toValue(r))) {
        var instance = {
            toMatch: toMatch,
            toContains: toContains,
            changed: changed,
            changedTimes: changedTimes,
            get not() {
                return createUntil(r, !isNot);
            }
        };
        return instance;
    }
    else {
        var instance = {
            toMatch: toMatch,
            toBe: toBe,
            toBeTruthy: toBeTruthy,
            toBeNull: toBeNull,
            toBeNaN: toBeNaN,
            toBeUndefined: toBeUndefined,
            changed: changed,
            changedTimes: changedTimes,
            get not() {
                return createUntil(r, !isNot);
            }
        };
        return instance;
    }
}
function until(r) {
    return createUntil(r);
}
function defaultComparator(value, othVal) {
    return value === othVal;
}
function useArrayDifference() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var _a;
    var list = args[0];
    var values = args[1];
    var compareFn = (_a = args[2]) != null ? _a : defaultComparator;
    if (typeof compareFn === "string") {
        var key_1 = compareFn;
        compareFn = function (value, othVal) { return value[key_1] === othVal[key_1]; };
    }
    return computed(function () { return toValue(list).filter(function (x) { return toValue(values).findIndex(function (y) { return compareFn(x, y); }) === -1; }); });
}
function useArrayEvery(list, fn) {
    return computed(function () { return toValue(list).every(function (element, index, array) { return fn(toValue(element), index, array); }); });
}
function useArrayFilter(list, fn) {
    return computed(function () { return toValue(list).map(function (i) { return toValue(i); }).filter(fn); });
}
function useArrayFind(list, fn) {
    return computed(function () { return toValue(toValue(list).find(function (element, index, array) { return fn(toValue(element), index, array); })); });
}
function useArrayFindIndex(list, fn) {
    return computed(function () { return toValue(list).findIndex(function (element, index, array) { return fn(toValue(element), index, array); }); });
}
function findLast(arr, cb) {
    var index = arr.length;
    while (index-- > 0) {
        if (cb(arr[index], index, arr))
            return arr[index];
    }
    return void 0;
}
function useArrayFindLast(list, fn) {
    return computed(function () { return toValue(!Array.prototype.findLast ? findLast(toValue(list), function (element, index, array) { return fn(toValue(element), index, array); }) : toValue(list).findLast(function (element, index, array) { return fn(toValue(element), index, array); })); });
}
function isArrayIncludesOptions(obj) {
    return isObject(obj) && containsProp(obj, "formIndex", "comparator");
}
function useArrayIncludes() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var _a;
    var list = args[0];
    var value = args[1];
    var comparator = args[2];
    var formIndex = 0;
    if (isArrayIncludesOptions(comparator)) {
        formIndex = (_a = comparator.fromIndex) != null ? _a : 0;
        comparator = comparator.comparator;
    }
    if (typeof comparator === "string") {
        var key_2 = comparator;
        comparator = function (element, value2) { return element[key_2] === toValue(value2); };
    }
    comparator = comparator != null ? comparator : function (element, value2) { return element === toValue(value2); };
    return computed(function () { return toValue(list).slice(formIndex).some(function (element, index, array) { return comparator(toValue(element), toValue(value), index, toValue(array)); }); });
}
function useArrayJoin(list, separator) {
    return computed(function () { return toValue(list).map(function (i) { return toValue(i); }).join(toValue(separator)); });
}
function useArrayMap(list, fn) {
    return computed(function () { return toValue(list).map(function (i) { return toValue(i); }).map(fn); });
}
function useArrayReduce(list, reducer) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    var reduceCallback = function (sum, value, index) { return reducer(toValue(sum), toValue(value), index); };
    return computed(function () {
        var resolved = toValue(list);
        return args.length ? resolved.reduce(reduceCallback, toValue(args[0])) : resolved.reduce(reduceCallback);
    });
}
function useArraySome(list, fn) {
    return computed(function () { return toValue(list).some(function (element, index, array) { return fn(toValue(element), index, array); }); });
}
function uniq(array) {
    return Array.from(new Set(array));
}
function uniqueElementsBy(array, fn) {
    return array.reduce(function (acc, v) {
        if (!acc.some(function (x) { return fn(v, x, array); }))
            acc.push(v);
        return acc;
    }, []);
}
function useArrayUnique(list, compareFn) {
    return computed(function () {
        var resolvedList = toValue(list).map(function (element) { return toValue(element); });
        return compareFn ? uniqueElementsBy(resolvedList, compareFn) : uniq(resolvedList);
    });
}
function useCounter(initialValue, options) {
    if (initialValue === void 0) { initialValue = 0; }
    if (options === void 0) { options = {}; }
    var _initialValue = unref(initialValue);
    var count = ref(initialValue);
    var _c = options.max, max = _c === void 0 ? Number.POSITIVE_INFINITY : _c, _d = options.min, min = _d === void 0 ? Number.NEGATIVE_INFINITY : _d;
    var inc = function (delta) {
        if (delta === void 0) { delta = 1; }
        return count.value = Math.max(Math.min(max, count.value + delta), min);
    };
    var dec = function (delta) {
        if (delta === void 0) { delta = 1; }
        return count.value = Math.min(Math.max(min, count.value - delta), max);
    };
    var get = function () { return count.value; };
    var set = function (val) { return count.value = Math.max(min, Math.min(max, val)); };
    var reset = function (val) {
        if (val === void 0) { val = _initialValue; }
        _initialValue = val;
        return set(val);
    };
    return { count: count, inc: inc, dec: dec, get: get, set: set, reset: reset };
}
var REGEX_PARSE = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[T\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/i;
var REGEX_FORMAT = /[YMDHhms]o|\[([^\]]+)\]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a{1,2}|A{1,2}|m{1,2}|s{1,2}|Z{1,2}|SSS/g;
function defaultMeridiem(hours, minutes, isLowercase, hasPeriod) {
    var m = hours < 12 ? "AM" : "PM";
    if (hasPeriod)
        m = m.split("").reduce(function (acc, curr) { return acc += "".concat(curr, "."); }, "");
    return isLowercase ? m.toLowerCase() : m;
}
function formatOrdinal(num) {
    var suffixes = ["th", "st", "nd", "rd"];
    var v = num % 100;
    return num + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
}
function formatDate(date, formatStr, options) {
    if (options === void 0) { options = {}; }
    var _a;
    var years = date.getFullYear();
    var month = date.getMonth();
    var days = date.getDate();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    var milliseconds = date.getMilliseconds();
    var day = date.getDay();
    var meridiem = (_a = options.customMeridiem) != null ? _a : defaultMeridiem;
    var matches = {
        Yo: function () { return formatOrdinal(years); },
        YY: function () { return String(years).slice(-2); },
        YYYY: function () { return years; },
        M: function () { return month + 1; },
        Mo: function () { return formatOrdinal(month + 1); },
        MM: function () { return "".concat(month + 1).padStart(2, "0"); },
        MMM: function () { return date.toLocaleDateString(options.locales, { month: "short" }); },
        MMMM: function () { return date.toLocaleDateString(options.locales, { month: "long" }); },
        D: function () { return String(days); },
        Do: function () { return formatOrdinal(days); },
        DD: function () { return "".concat(days).padStart(2, "0"); },
        H: function () { return String(hours); },
        Ho: function () { return formatOrdinal(hours); },
        HH: function () { return "".concat(hours).padStart(2, "0"); },
        h: function () { return "".concat(hours % 12 || 12).padStart(1, "0"); },
        ho: function () { return formatOrdinal(hours % 12 || 12); },
        hh: function () { return "".concat(hours % 12 || 12).padStart(2, "0"); },
        m: function () { return String(minutes); },
        mo: function () { return formatOrdinal(minutes); },
        mm: function () { return "".concat(minutes).padStart(2, "0"); },
        s: function () { return String(seconds); },
        so: function () { return formatOrdinal(seconds); },
        ss: function () { return "".concat(seconds).padStart(2, "0"); },
        SSS: function () { return "".concat(milliseconds).padStart(3, "0"); },
        d: function () { return day; },
        dd: function () { return date.toLocaleDateString(options.locales, { weekday: "narrow" }); },
        ddd: function () { return date.toLocaleDateString(options.locales, { weekday: "short" }); },
        dddd: function () { return date.toLocaleDateString(options.locales, { weekday: "long" }); },
        A: function () { return meridiem(hours, minutes); },
        AA: function () { return meridiem(hours, minutes, false, true); },
        a: function () { return meridiem(hours, minutes, true); },
        aa: function () { return meridiem(hours, minutes, true, true); }
    };
    return formatStr.replace(REGEX_FORMAT, function (match, $1) {
        var _a2, _b;
        return (_b = $1 != null ? $1 : (_a2 = matches[match]) == null ? void 0 : _a2.call(matches)) != null ? _b : match;
    });
}
function normalizeDate(date) {
    if (date === null)
        return new Date(Number.NaN);
    if (date === void 0)
        return /* @__PURE__ */ new Date();
    if (date instanceof Date)
        return new Date(date);
    if (typeof date === "string" && !/Z$/i.test(date)) {
        var d = date.match(REGEX_PARSE);
        if (d) {
            var m = d[2] - 1 || 0;
            var ms = (d[7] || "0").substring(0, 3);
            return new Date(d[1], m, d[3] || 1, d[4] || 0, d[5] || 0, d[6] || 0, ms);
        }
    }
    return new Date(date);
}
function useDateFormat(date, formatStr, options) {
    if (formatStr === void 0) { formatStr = "HH:mm:ss"; }
    if (options === void 0) { options = {}; }
    return computed(function () { return formatDate(normalizeDate(toValue(date)), toValue(formatStr), options); });
}
function useIntervalFn(cb, interval, options) {
    if (interval === void 0) { interval = 1e3; }
    if (options === void 0) { options = {}; }
    var _c = options.immediate, immediate = _c === void 0 ? true : _c, _d = options.immediateCallback, immediateCallback = _d === void 0 ? false : _d;
    var timer = null;
    var isActive = ref(false);
    function clean() {
        if (timer) {
            clearInterval(timer);
            timer = null;
        }
    }
    function pause() {
        isActive.value = false;
        clean();
    }
    function resume() {
        var intervalValue = toValue(interval);
        if (intervalValue <= 0)
            return;
        isActive.value = true;
        if (immediateCallback)
            cb();
        clean();
        timer = setInterval(cb, intervalValue);
    }
    if (immediate && isClient)
        resume();
    if (isRef(interval) || typeof interval === "function") {
        var stopWatch = watch(interval, function () {
            if (isActive.value && isClient)
                resume();
        });
        tryOnScopeDispose(stopWatch);
    }
    tryOnScopeDispose(pause);
    return {
        isActive: isActive,
        pause: pause,
        resume: resume
    };
}
function useInterval(interval, options) {
    if (interval === void 0) { interval = 1e3; }
    if (options === void 0) { options = {}; }
    var _c = options.controls, exposeControls = _c === void 0 ? false : _c, _d = options.immediate, immediate = _d === void 0 ? true : _d, callback = options.callback;
    var counter = ref(0);
    var update = function () { return counter.value += 1; };
    var reset = function () {
        counter.value = 0;
    };
    var controls = useIntervalFn(callback ? function () {
        update();
        callback(counter.value);
    } : update, interval, { immediate: immediate });
    if (exposeControls) {
        return __assign({ counter: counter, reset: reset }, controls);
    }
    else {
        return counter;
    }
}
function useLastChanged(source, options) {
    if (options === void 0) { options = {}; }
    var _a;
    var ms = ref((_a = options.initialValue) != null ? _a : null);
    watch(source, function () { return ms.value = timestamp(); }, options);
    return ms;
}
function useTimeoutFn(cb, interval, options) {
    if (options === void 0) { options = {}; }
    var _c = options.immediate, immediate = _c === void 0 ? true : _c;
    var isPending = ref(false);
    var timer = null;
    function clear() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    }
    function stop() {
        isPending.value = false;
        clear();
    }
    function start() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clear();
        isPending.value = true;
        timer = setTimeout(function () {
            isPending.value = false;
            timer = null;
            cb.apply(void 0, __spreadArray([], __read(args), false));
        }, toValue(interval));
    }
    if (immediate) {
        isPending.value = true;
        if (isClient)
            start();
    }
    tryOnScopeDispose(stop);
    return {
        isPending: readonly(isPending),
        start: start,
        stop: stop
    };
}
function useTimeout(interval, options) {
    if (interval === void 0) { interval = 1e3; }
    if (options === void 0) { options = {}; }
    var _c = options.controls, exposeControls = _c === void 0 ? false : _c, callback = options.callback;
    var controls = useTimeoutFn(callback != null ? callback : noop, interval, options);
    var ready = computed(function () { return !controls.isPending.value; });
    if (exposeControls) {
        return __assign({ ready: ready }, controls);
    }
    else {
        return ready;
    }
}
function useToNumber(value, options) {
    if (options === void 0) { options = {}; }
    var _c = options.method, method = _c === void 0 ? "parseFloat" : _c, radix = options.radix, nanToZero = options.nanToZero;
    return computed(function () {
        var resolved = toValue(value);
        if (typeof resolved === "string")
            resolved = Number[method](resolved, radix);
        if (nanToZero && Number.isNaN(resolved))
            resolved = 0;
        return resolved;
    });
}
function useToString(value) {
    return computed(function () { return "".concat(toValue(value)); });
}
function useToggle(initialValue, options) {
    if (initialValue === void 0) { initialValue = false; }
    if (options === void 0) { options = {}; }
    var _c = options.truthyValue, truthyValue = _c === void 0 ? true : _c, _d = options.falsyValue, falsyValue = _d === void 0 ? false : _d;
    var valueIsRef = isRef(initialValue);
    var _value = ref(initialValue);
    function toggle(value) {
        if (arguments.length) {
            _value.value = value;
            return _value.value;
        }
        else {
            var truthy = toValue(truthyValue);
            _value.value = _value.value === truthy ? toValue(falsyValue) : truthy;
            return _value.value;
        }
    }
    if (valueIsRef)
        return toggle;
    else
        return [_value, toggle];
}
function watchArray(source, cb, options) {
    var oldList = (options == null ? void 0 : options.immediate) ? [] : __spreadArray([], __read(source instanceof Function ? source() : Array.isArray(source) ? source : toValue(source)), false);
    return watch(source, function (newList, _, onCleanup) {
        var e_2, _c;
        var oldListRemains = Array.from({ length: oldList.length });
        var added = [];
        try {
            for (var newList_1 = __values(newList), newList_1_1 = newList_1.next(); !newList_1_1.done; newList_1_1 = newList_1.next()) {
                var obj = newList_1_1.value;
                var found = false;
                for (var i = 0; i < oldList.length; i++) {
                    if (!oldListRemains[i] && obj === oldList[i]) {
                        oldListRemains[i] = true;
                        found = true;
                        break;
                    }
                }
                if (!found)
                    added.push(obj);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (newList_1_1 && !newList_1_1.done && (_c = newList_1.return)) _c.call(newList_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        var removed = oldList.filter(function (_2, i) { return !oldListRemains[i]; });
        cb(newList, oldList, added, removed, onCleanup);
        oldList = __spreadArray([], __read(newList), false);
    }, options);
}
function watchAtMost(source, cb, options) {
    var count = options.count, watchOptions = __rest(options, ["count"]);
    var current = ref(0);
    var stop = watchWithFilter(source, function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        current.value += 1;
        if (current.value >= toValue(count))
            nextTick(function () { return stop(); });
        cb.apply(void 0, __spreadArray([], __read(args), false));
    }, watchOptions);
    return { count: current, stop: stop };
}
function watchDebounced(source, cb, options) {
    if (options === void 0) { options = {}; }
    var _c = options.debounce, debounce = _c === void 0 ? 0 : _c, _d = options.maxWait, maxWait = _d === void 0 ? void 0 : _d, watchOptions = __rest(options, ["debounce", "maxWait"]);
    return watchWithFilter(source, cb, __assign(__assign({}, watchOptions), { eventFilter: debounceFilter(debounce, { maxWait: maxWait }) }));
}
function watchDeep(source, cb, options) {
    return watch(source, cb, __assign(__assign({}, options), { deep: true }));
}
function watchIgnorable(source, cb, options) {
    if (options === void 0) { options = {}; }
    var _c = options.eventFilter, eventFilter = _c === void 0 ? bypassFilter : _c, watchOptions = __rest(options, ["eventFilter"]);
    var filteredCb = createFilterWrapper(eventFilter, cb);
    var ignoreUpdates;
    var ignorePrevAsyncUpdates;
    var stop;
    if (watchOptions.flush === "sync") {
        var ignore_1 = ref(false);
        ignorePrevAsyncUpdates = function () {
        };
        ignoreUpdates = function (updater) {
            ignore_1.value = true;
            updater();
            ignore_1.value = false;
        };
        stop = watch(source, function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (!ignore_1.value)
                filteredCb.apply(void 0, __spreadArray([], __read(args), false));
        }, watchOptions);
    }
    else {
        var disposables_1 = [];
        var ignoreCounter_1 = ref(0);
        var syncCounter_1 = ref(0);
        ignorePrevAsyncUpdates = function () {
            ignoreCounter_1.value = syncCounter_1.value;
        };
        disposables_1.push(watch(source, function () {
            syncCounter_1.value++;
        }, __assign(__assign({}, watchOptions), { flush: "sync" })));
        ignoreUpdates = function (updater) {
            var syncCounterPrev = syncCounter_1.value;
            updater();
            ignoreCounter_1.value += syncCounter_1.value - syncCounterPrev;
        };
        disposables_1.push(watch(source, function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var ignore = ignoreCounter_1.value > 0 && ignoreCounter_1.value === syncCounter_1.value;
            ignoreCounter_1.value = 0;
            syncCounter_1.value = 0;
            if (ignore)
                return;
            filteredCb.apply(void 0, __spreadArray([], __read(args), false));
        }, watchOptions));
        stop = function () {
            disposables_1.forEach(function (fn) { return fn(); });
        };
    }
    return { stop: stop, ignoreUpdates: ignoreUpdates, ignorePrevAsyncUpdates: ignorePrevAsyncUpdates };
}
function watchImmediate(source, cb, options) {
    return watch(source, cb, __assign(__assign({}, options), { immediate: true }));
}
function watchOnce(source, cb, options) {
    var stop = watch(source, function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        nextTick(function () { return stop(); });
        return cb.apply(void 0, __spreadArray([], __read(args), false));
    }, options);
    return stop;
}
function watchThrottled(source, cb, options) {
    if (options === void 0) { options = {}; }
    var _c = options.throttle, throttle = _c === void 0 ? 0 : _c, _d = options.trailing, trailing = _d === void 0 ? true : _d, _e = options.leading, leading = _e === void 0 ? true : _e, watchOptions = __rest(options, ["throttle", "trailing", "leading"]);
    return watchWithFilter(source, cb, __assign(__assign({}, watchOptions), { eventFilter: throttleFilter(throttle, trailing, leading) }));
}
function watchTriggerable(source, cb, options) {
    if (options === void 0) { options = {}; }
    var cleanupFn;
    function onEffect() {
        if (!cleanupFn)
            return;
        var fn = cleanupFn;
        cleanupFn = void 0;
        fn();
    }
    function onCleanup(callback) {
        cleanupFn = callback;
    }
    var _cb = function (value, oldValue) {
        onEffect();
        return cb(value, oldValue, onCleanup);
    };
    var res = watchIgnorable(source, _cb, options);
    var ignoreUpdates = res.ignoreUpdates;
    var trigger = function () {
        var res2;
        ignoreUpdates(function () {
            res2 = _cb(getWatchSources(source), getOldValue(source));
        });
        return res2;
    };
    return __assign(__assign({}, res), { trigger: trigger });
}
function getWatchSources(sources) {
    if (isReactive(sources))
        return sources;
    if (Array.isArray(sources))
        return sources.map(function (item) { return toValue(item); });
    return toValue(sources);
}
function getOldValue(source) {
    return Array.isArray(source) ? source.map(function () { return void 0; }) : void 0;
}
function whenever(source, cb, options) {
    var stop = watch(source, function (v, ov, onInvalidate) {
        if (v) {
            if (options == null ? void 0 : options.once)
                nextTick(function () { return stop(); });
            cb(v, ov, onInvalidate);
        }
    }, __assign(__assign({}, options), { once: false }));
    return stop;
}
export { assert, refAutoReset as autoResetRef, bypassFilter, camelize, clamp, computedEager, computedWithControl, containsProp, computedWithControl as controlledComputed, controlledRef, createEventHook, createFilterWrapper, createGlobalState, createInjectionState, reactify as createReactiveFn, createSharedComposable, createSingletonPromise, debounceFilter, refDebounced as debouncedRef, watchDebounced as debouncedWatch, directiveHooks, computedEager as eagerComputed, extendRef, formatDate, get, getLifeCycleTarget, hasOwn, hyphenate, identity, watchIgnorable as ignorableWatch, increaseWithUnit, injectLocal, invoke, isClient, isDef, isDefined, isIOS, isObject, isWorker, makeDestructurable, noop, normalizeDate, notNullish, now, objectEntries, objectOmit, objectPick, pausableFilter, watchPausable as pausableWatch, promiseTimeout, provideLocal, rand, reactify, reactifyObject, reactiveComputed, reactiveOmit, reactivePick, refAutoReset, refDebounced, refDefault, refThrottled, refWithControl, resolveRef, resolveUnref, set, syncRef, syncRefs, throttleFilter, refThrottled as throttledRef, watchThrottled as throttledWatch, timestamp, toReactive, toRef, toRefs, toValue, tryOnBeforeMount, tryOnBeforeUnmount, tryOnMounted, tryOnScopeDispose, tryOnUnmounted, until, useArrayDifference, useArrayEvery, useArrayFilter, useArrayFind, useArrayFindIndex, useArrayFindLast, useArrayIncludes, useArrayJoin, useArrayMap, useArrayReduce, useArraySome, useArrayUnique, useCounter, useDateFormat, refDebounced as useDebounce, useDebounceFn, useInterval, useIntervalFn, useLastChanged, refThrottled as useThrottle, useThrottleFn, useTimeout, useTimeoutFn, useToNumber, useToString, useToggle, watchArray, watchAtMost, watchDebounced, watchDeep, watchIgnorable, watchImmediate, watchOnce, watchPausable, watchThrottled, watchTriggerable, watchWithFilter, whenever };
